import { FunctionComponent } from "react"

import {
	BenchmarkCommonTemplate,
	BenchmarkPenetrationTemplate,
} from "./Templates"

import { BenchmarkTemplateProps } from "../../interfaces"
import { MetricName } from "../MetricsSelect/interfaces"

type BenchmarkTemplate = FunctionComponent<BenchmarkTemplateProps> | null

const BenchmarkTemplateManagerConfig: Record<MetricName, BenchmarkTemplate> = {
	clients: BenchmarkCommonTemplate,
	sales: BenchmarkCommonTemplate,
	units: BenchmarkCommonTemplate,
	transactions: BenchmarkCommonTemplate,
	penetration: BenchmarkPenetrationTemplate,
	"purchase-frequency": BenchmarkCommonTemplate,
	"average-price-per-item": BenchmarkCommonTemplate,
	"average-ticket": BenchmarkCommonTemplate,
	"average-spend": BenchmarkCommonTemplate,
	"items-per-visit": BenchmarkCommonTemplate,
	"stores-selling": BenchmarkCommonTemplate,
}

export default BenchmarkTemplateManagerConfig
